/** Bank › Books (screens §2.1): a product-level table for loans, securities, deposits or funding, with its footer and a month-by-month history view. */
import type { ProductLine } from "@bsim/domain";
import { GxNotes } from "../theme/GxNotes";
import { GxDataTable, type TableRow } from "./DataTable";
import { BOOK_TABS, bookColumns, depositsFooter, bookRows, fundingFooter, historyRows, loanFooter, securitiesFooter, withoutEmptyColumns, type BookTab, type MonthlyBooks } from "./books";

export function Books({ tab, products, aociAfsUsd, wholesaleShare, monthly, monthLabel, selectedId, onSelect }: {
  readonly tab: BookTab; readonly products: readonly ProductLine[]; readonly aociAfsUsd: number; readonly wholesaleShare: number | undefined;
  /** Set while the History toggle is on: one column per month. */
  readonly monthly: readonly MonthlyBooks[] | null; readonly monthLabel: (month: number) => string;
  readonly selectedId?: string | null; readonly onSelect?: (row: TableRow) => void;
}) {
  const { label, first } = BOOK_TABS[tab];
  const footer = tab === "loans" ? loanFooter(products) : tab === "securities" ? securitiesFooter(products, aociAfsUsd) : tab === "funding" ? fundingFooter(wholesaleShare) : tab === "deposits" ? depositsFooter(products) : null;
  const shown = monthly === null ? withoutEmptyColumns(bookColumns(tab), bookRows(tab, products)) : { columns: monthly.map((m) => monthLabel(m.month)), rows: historyRows(tab, products, monthly) };
  const rows = shown.rows;
  if (rows.length === 0) return <p className="gx-muted gx-fin-check" data-testid={`financials.books.${tab}.empty`}>No {label.toLowerCase()} detail is available for this period.</p>;
  return (
    <>
      <GxDataTable testId={`financials.books.${tab}`} caption={`${label}${monthly === null ? "" : ", month by month"}`} firstColumn={first} dense percentInHeader
        columns={shown.columns} rows={rows} {...(selectedId === undefined ? {} : { selectedId })} {...(onSelect === undefined ? {} : { onSelect })} />
      <GxNotes testId={`financials.books.${tab}.footer`} notes={[footer]} />
    </>
  );
}
